import { CUSTOM_DATASOURCES, CUSTOM_UNINSTALL } from '../../constants/dataFieldKeys/dataSources';
import { BLOCKED_CUSTOM_EVENT_PREFIX, CUSTOM_EVENT_PREFIX } from '../../constants/dataFieldKeys/reportColumnKeys';
import { isBlockedCustomEvent } from './isBlockedCustomEvent';

export const getCustomEventName = (key: string) => {
  if (isBlockedCustomEvent(key)) {
    return 'blocked ' + key.slice(BLOCKED_CUSTOM_EVENT_PREFIX.length);
  }

  if (key === CUSTOM_UNINSTALL) {
    return CUSTOM_DATASOURCES[CUSTOM_UNINSTALL];
  }

  return key.slice(CUSTOM_EVENT_PREFIX.length);
};
